


// import React, { useEffect, useState } from 'react';
// import {
//   Button, Modal, Form, Input, InputNumber,
//   Space, Tag, Popconfirm, message, Typography, Select,
//   Card, Progress, Divider, Tooltip,
// } from 'antd';
// import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
// import { skillGroupsService, themeService } from '../firebase/services';

// const { Title } = Typography;

// // Fallback palette — used while theme is loading or if fetch fails
// const FALLBACK_COLORS = {
//   '--acid':   '#c8f04a',
//   '--cyan':   '#00e5ff',
//   '--purple': '#a78bfa',
//   '--red':    '#ff6b6b',
//   '--muted':  '#2a2a2a',
// };

// export default function SkillsPage() {
//   const [data,        setData]        = useState([]);
//   const [loading,     setLoading]     = useState(false);
//   const [modalOpen,   setModalOpen]   = useState(false);
//   const [editing,     setEditing]     = useState(null);
//   const [items,       setItems]       = useState([{ name: '', level: 80 }]);
//   const [form]        = Form.useForm();

//   // ── Theme colors ────────────────────────────────────────────────────────────
//   const [themeColors,   setThemeColors]   = useState(FALLBACK_COLORS);
//   const [themeLoading,  setThemeLoading]  = useState(false);
//   // For adding a new colour right inside the dropdown
//   const [newVarName,  setNewVarName]  = useState('');
//   const [newVarHex,   setNewVarHex]   = useState('#000000');

//   const loadTheme = async () => {
//     setThemeLoading(true);
//     try {
//       const data = await themeService.get();
//       if (data && typeof data === 'object') {
//         // Keep only CSS variable keys (--xxx) and valid hex values
//         const filtered = Object.fromEntries(
//           Object.entries(data).filter(
//             ([k, v]) => k.startsWith('--') && /^#[0-9a-fA-F]{6}$/.test(v)
//           )
//         );
//         setThemeColors(Object.keys(filtered).length ? filtered : FALLBACK_COLORS);
//       }
//     } catch {
//       // silently fall back — theme colours are cosmetic
//     } finally {
//       setThemeLoading(false);
//     }
//   };

//   // Helper: resolve a stored color value (e.g. '#c8f04a') to its CSS-var name,
//   // or return the raw hex if no match. Used only for display.
//   const hexToVarName = (hex) => {
//     const entry = Object.entries(themeColors).find(([, v]) => v === hex);
//     return entry ? entry[0] : null;
//   };

//   // The default color for NEW groups: prefer --acid, then first available
//   const defaultColor = themeColors['--acid'] ?? Object.values(themeColors)[0] ?? '#c8f04a';

//   // ── Data load ───────────────────────────────────────────────────────────────
//   const load = async () => {
//     setLoading(true);
//     try { setData(await skillGroupsService.getAll()); }
//     catch { message.error('Failed to load skills'); }
//     finally { setLoading(false); }
//   };

//   useEffect(() => {
//     load();
//     loadTheme();
//   }, []);

//   // ── Modal helpers ────────────────────────────────────────────────────────────
//   const openAdd = () => {
//     setEditing(null);
//     form.resetFields();
//     form.setFieldsValue({ color: defaultColor });
//     setItems([{ name: '', level: 80 }]);
//     setModalOpen(true);
//   };

//   const openEdit = (record) => {
//     setEditing(record);
//     form.setFieldsValue({ cat: record.cat, color: record.color });
//     setItems((record.items || []).map(item =>
//       typeof item === 'object' && !Array.isArray(item)
//         ? { name: item.name || '', level: item.level || 80 }
//         : { name: item[0] || '', level: item[1] || 80 }
//     ));
//     setModalOpen(true);
//   };

//   const handleSave = async () => {
//     try {
//       const vals = await form.validateFields();
//       const payload = {
//         cat:   vals.cat,
//         color: vals.color,
//         items: items.filter(i => i.name).map(i => ({ name: i.name, level: Number(i.level) })),
//       };
//       if (editing) {
//         await skillGroupsService.update(editing.id, payload);
//         message.success('Skill group updated');
//       } else {
//         await skillGroupsService.add(payload);
//         message.success('Skill group added');
//       }
//       setModalOpen(false);
//       load();
//     } catch (e) {
//       if (e?.errorFields) return;
//       message.error('Save failed: ' + (e.message || ''));
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await skillGroupsService.remove(id);
//       message.success('Deleted');
//       load();
//     } catch { message.error('Delete failed'); }
//   };

//   const addItem    = () => setItems([...items, { name: '', level: 80 }]);
//   const removeItem = (i) => setItems(items.filter((_, idx) => idx !== i));
//   const updateItem = (i, field, val) => {
//     const copy = [...items];
//     copy[i] = { ...copy[i], [field]: val };
//     setItems(copy);
//   };

//   const itemName  = (item) => typeof item === 'object' && !Array.isArray(item) ? item.name  : item[0];
//   const itemLevel = (item) => typeof item === 'object' && !Array.isArray(item) ? item.level : item[1];

//   // ── Add a brand-new colour to the local theme palette (and persist it) ──────
//   const handleAddThemeColor = async () => {
//     const raw = newVarName.trim();
//     const name = raw.startsWith('--') ? raw : `--${raw}`;
//     if (!name || name === '--') { message.warning('Enter a variable name'); return; }
//     if (!/^#[0-9a-fA-F]{6}$/.test(newVarHex)) { message.warning('Enter a valid hex colour'); return; }
//     if (themeColors[name]) { message.warning('Variable already exists'); return; }

//     const updated = { ...themeColors, [name]: newVarHex };
//     setThemeColors(updated);

//     // Persist via themeService so ThemePage stays in sync
//     try {
//       await themeService.save(updated);
//       message.success(`${name} added to theme`);
//     } catch {
//       message.error('Colour added locally but failed to save to theme');
//     }

//     // Auto-select the new colour in the form
//     form.setFieldsValue({ color: newVarHex });
//     setNewVarName('');
//     setNewVarHex('#000000');
//   };

//   // ── Colour dropdown option renderer ─────────────────────────────────────────
//   const colorOptions = Object.entries(themeColors).map(([varName, hex]) => ({
//     label: (
//       <Space>
//         <span style={{
//           display: 'inline-block', width: 14, height: 14,
//           borderRadius: 3, background: hex,
//           border: '1px solid rgba(0,0,0,0.15)',
//           flexShrink: 0,
//         }} />
//         <code style={{ fontSize: 12 }}>{varName}</code>
//         <span style={{ color: '#888', fontSize: 11 }}>{hex.toUpperCase()}</span>
//       </Space>
//     ),
//     value: hex,
//   }));

//   return (
//     <>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
//         <Title level={4} style={{ margin: 0 }}>Skill Groups</Title>
//         <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Add Group</Button>
//       </div>

//       {loading ? <div>Loading...</div> : (
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
//           {data.map(group => (
//             <Card
//               key={group.id}
//               title={<Tag color={group.color} style={{ color: '#000', fontWeight: 700 }}>{group.cat}</Tag>}
//               extra={
//                 <Space>
//                   <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(group)} />
//                   <Popconfirm title="Delete this group?" onConfirm={() => handleDelete(group.id)}>
//                     <Button size="small" danger icon={<DeleteOutlined />} />
//                   </Popconfirm>
//                 </Space>
//               }
//               size="small"
//             >
//               {(group.items || []).map((item, idx) => (
//                 <div key={idx} style={{ marginBottom: 8 }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
//                     <span style={{ fontSize: 13 }}>{itemName(item)}</span>
//                     <span style={{ fontSize: 12, color: '#888' }}>{itemLevel(item)}%</span>
//                   </div>
//                   <Progress percent={itemLevel(item)} strokeColor={group.color} showInfo={false} size="small" />
//                 </div>
//               ))}
//             </Card>
//           ))}
//         </div>
//       )}

//       <Modal
//         title={editing ? 'Edit Skill Group' : 'Add Skill Group'}
//         open={modalOpen}
//         onOk={handleSave}
//         onCancel={() => setModalOpen(false)}
//         okText="Save"
//         width={520}
//       >
//         <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
//           <Form.Item name="cat" label="Category Name" rules={[{ required: true }]}>
//             <Input placeholder="Frontend" />
//           </Form.Item>

//           {/* ── Accent colour — live from theme ── */}
//           <Form.Item name="color" label="Accent Color">
//             <Select
//               loading={themeLoading}
//               options={colorOptions}
//               optionLabelProp="label"
//               dropdownRender={(menu) => (
//                 <>
//                   {menu}
//                   <Divider style={{ margin: '8px 0' }} />
//                   {/* Inline "add colour" row */}
//                   <div style={{ padding: '4px 8px 8px' }}>
//                     <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Add new colour to theme</div>
//                     <Space.Compact style={{ width: '100%' }}>
//                       <Input
//                         placeholder="--variable-name"
//                         value={newVarName}
//                         onChange={e => setNewVarName(e.target.value)}
//                         style={{ fontFamily: 'monospace', flex: 1 }}
//                         onPressEnter={handleAddThemeColor}
//                       />
//                       {/* Native colour picker hidden behind a swatch */}
//                       <Tooltip title="Pick colour">
//                         <div style={{ position: 'relative', width: 32, flexShrink: 0 }}>
//                           <div style={{
//                             width: 32, height: 32,
//                             background: newVarHex,
//                             border: '1px solid #d9d9d9',
//                             borderLeft: 'none',
//                             cursor: 'pointer',
//                           }} />
//                           <input
//                             type="color"
//                             value={newVarHex}
//                             onChange={e => setNewVarHex(e.target.value)}
//                             style={{ position: 'absolute', inset: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
//                           />
//                         </div>
//                       </Tooltip>
//                       <Input
//                         value={newVarHex.toUpperCase()}
//                         maxLength={7}
//                         style={{ fontFamily: 'monospace', width: 90 }}
//                         onChange={e => {
//                           let hex = e.target.value.trim();
//                           if (!hex.startsWith('#')) hex = '#' + hex;
//                           if (/^#[0-9a-fA-F]{6}$/.test(hex)) setNewVarHex(hex);
//                         }}
//                       />
//                       <Button icon={<PlusOutlined />} onClick={handleAddThemeColor} />
//                     </Space.Compact>
//                   </div>
//                 </>
//               )}
//             >
//               {/* options are passed via the `options` prop above */}
//             </Select>
//           </Form.Item>

//           {/* ── Selected colour preview ── */}
//           <Form.Item shouldUpdate={(prev, curr) => prev.color !== curr.color} noStyle>
//             {({ getFieldValue }) => {
//               const hex = getFieldValue('color');
//               const varName = hex ? hexToVarName(hex) : null;
//               return hex ? (
//                 <div style={{
//                   display: 'flex', alignItems: 'center', gap: 10,
//                   marginTop: -12, marginBottom: 16,
//                   padding: '6px 10px',
//                   background: '#fafafa',
//                   borderRadius: 6,
//                   border: '1px solid #f0f0f0',
//                 }}>
//                   <div style={{
//                     width: 22, height: 22, borderRadius: 4,
//                     background: hex, flexShrink: 0,
//                     border: '1px solid rgba(0,0,0,0.1)',
//                   }} />
//                   {varName && <code style={{ fontSize: 12, color: '#555' }}>{varName}</code>}
//                   <span style={{ fontSize: 12, color: '#888', fontFamily: 'monospace' }}>{hex.toUpperCase()}</span>
//                 </div>
//               ) : null;
//             }}
//           </Form.Item>

//           <Divider>Skills</Divider>
//           {items.map((item, i) => (
//             <Space key={i} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
//               <Input
//                 placeholder="Skill name"
//                 value={item.name}
//                 onChange={e => updateItem(i, 'name', e.target.value)}
//                 style={{ width: 200 }}
//               />
//               <InputNumber
//                 min={0} max={100}
//                 value={item.level}
//                 onChange={v => updateItem(i, 'level', v)}
//                 formatter={v => `${v}%`}
//                 parser={v => v.replace('%', '')}
//                 style={{ width: 90 }}
//               />
//               <Button danger size="small" onClick={() => removeItem(i)} disabled={items.length === 1}>✕</Button>
//             </Space>
//           ))}
//           <Button type="dashed" onClick={addItem} icon={<PlusOutlined />} style={{ width: '100%' }}>
//             Add Skill
//           </Button>
//         </Form>
//       </Modal>
//     </>
//   );
// }

import React, { useEffect, useState } from 'react';
import {
  Button, Modal, Form, Input, InputNumber,
  Space, Tag, Popconfirm, message, Typography, Select,
  Card, Progress, Divider, Tooltip, Slider, Row, Col,
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import { skillGroupsService, skillsMetaService, themeService } from '../firebase/services';

const { Title, Text } = Typography;

const FALLBACK_COLORS = {
  '--acid':   '#c8f04a',
  '--cyan':   '#00e5ff',
  '--muted':  '#2a2a2a',
};

const DEFAULT_META = {
  floatingImage:  '',
  desktopWidthVw: 22,
  mobileWidthVw:  48,
};

export default function SkillsPage() {
  const [data,        setData]        = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [modalOpen,   setModalOpen]   = useState(false);
  const [editing,     setEditing]     = useState(null);
  const [items,       setItems]       = useState([{ name: '', level: 80 }]);
  const [form]        = Form.useForm();

  // ── Skills meta (floating image + widths) ───────────────────────────────────
  const [skillsMeta,  setSkillsMeta]  = useState(DEFAULT_META);
  const [metaSaving,  setMetaSaving]  = useState(false);

  // ── Theme colors ────────────────────────────────────────────────────────────
  const [themeColors,  setThemeColors]  = useState(FALLBACK_COLORS);
  const [themeLoading, setThemeLoading] = useState(false);
  const [newVarName,   setNewVarName]   = useState('');
  const [newVarHex,    setNewVarHex]    = useState('#000000');

  // ── Load theme ───────────────────────────────────────────────────────────────
  const loadTheme = async () => {
    setThemeLoading(true);
    try {
      const data = await themeService.get();
      if (data && typeof data === 'object') {
        const filtered = Object.fromEntries(
          Object.entries(data).filter(
            ([k, v]) => k.startsWith('--') && /^#[0-9a-fA-F]{6}$/.test(v)
          )
        );
        setThemeColors(Object.keys(filtered).length ? filtered : FALLBACK_COLORS);
      }
    } catch {
      // silently fall back
    } finally {
      setThemeLoading(false);
    }
  };

  const hexToVarName = (hex) => {
    const entry = Object.entries(themeColors).find(([, v]) => v === hex);
    return entry ? entry[0] : null;
  };

  const defaultColor = themeColors['--acid'] ?? Object.values(themeColors)[0] ?? '#c8f04a';

  // ── Load skill groups + meta ─────────────────────────────────────────────────
  const load = async () => {
    setLoading(true);
    try {
      const [groups, meta] = await Promise.all([
        skillGroupsService.getAll(),
        skillsMetaService.get(),
      ]);
      setData(groups);
      if (meta) {
        setSkillsMeta({
          floatingImage:  meta.floatingImage  || DEFAULT_META.floatingImage,
          desktopWidthVw: meta.desktopWidthVw ?? DEFAULT_META.desktopWidthVw,
          mobileWidthVw:  meta.mobileWidthVw  ?? DEFAULT_META.mobileWidthVw,
        });
      }
    } catch {
      message.error('Failed to load skills');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    loadTheme();
  }, []);

  // ── Save all meta fields together ───────────────────────────────────────────
  const saveSkillsMeta = async () => {
    setMetaSaving(true);
    try {
      await skillsMetaService.save({
        floatingImage:  skillsMeta.floatingImage,
        desktopWidthVw: skillsMeta.desktopWidthVw,
        mobileWidthVw:  skillsMeta.mobileWidthVw,
      });
      message.success('Settings saved');
    } catch {
      message.error('Save failed');
    } finally {
      setMetaSaving(false);
    }
  };

  // ── Modal helpers ────────────────────────────────────────────────────────────
  const openAdd = () => {
    setEditing(null);
    form.resetFields();
    form.setFieldsValue({ color: defaultColor });
    setItems([{ name: '', level: 80 }]);
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditing(record);
    form.setFieldsValue({ cat: record.cat, color: record.color });
    setItems((record.items || []).map(item =>
      typeof item === 'object' && !Array.isArray(item)
        ? { name: item.name || '', level: item.level || 80 }
        : { name: item[0] || '', level: item[1] || 80 }
    ));
    setModalOpen(true);
  };

  const handleSave = async () => {
    try {
      const vals = await form.validateFields();
      const payload = {
        cat:   vals.cat,
        color: vals.color,
        items: items.filter(i => i.name).map(i => ({ name: i.name, level: Number(i.level) })),
      };
      if (editing) {
        await skillGroupsService.update(editing.id, payload);
        message.success('Skill group updated');
      } else {
        await skillGroupsService.add(payload);
        message.success('Skill group added');
      }
      setModalOpen(false);
      load();
    } catch (e) {
      if (e?.errorFields) return;
      message.error('Save failed: ' + (e.message || ''));
    }
  };

  const handleDelete = async (id) => {
    try {
      await skillGroupsService.remove(id);
      message.success('Deleted');
      load();
    } catch { message.error('Delete failed'); }
  };

  const addItem    = () => setItems([...items, { name: '', level: 80 }]);
  const removeItem = (i) => setItems(items.filter((_, idx) => idx !== i));
  const updateItem = (i, field, val) => {
    const copy = [...items];
    copy[i] = { ...copy[i], [field]: val };
    setItems(copy);
  };

  const itemName  = (item) => typeof item === 'object' && !Array.isArray(item) ? item.name  : item[0];
  const itemLevel = (item) => typeof item === 'object' && !Array.isArray(item) ? item.level : item[1];

  // ── Add new theme colour ─────────────────────────────────────────────────────
  const handleAddThemeColor = async () => {
    const raw  = newVarName.trim();
    const name = raw.startsWith('--') ? raw : `--${raw}`;
    if (!name || name === '--') { message.warning('Enter a variable name'); return; }
    if (!/^#[0-9a-fA-F]{6}$/.test(newVarHex)) { message.warning('Enter a valid hex colour'); return; }
    if (themeColors[name]) { message.warning('Variable already exists'); return; }

    const updated = { ...themeColors, [name]: newVarHex };
    setThemeColors(updated);

    try {
      await themeService.save(updated);
      message.success(`${name} added to theme`);
    } catch {
      message.error('Colour added locally but failed to save to theme');
    }

    form.setFieldsValue({ color: newVarHex });
    setNewVarName('');
    setNewVarHex('#000000');
  };

  // ── Colour dropdown options ──────────────────────────────────────────────────
  const colorOptions = Object.entries(themeColors).map(([varName, hex]) => ({
    label: (
      <Space>
        <span style={{
          display: 'inline-block', width: 14, height: 14,
          borderRadius: 3, background: hex,
          border: '1px solid rgba(0,0,0,0.15)',
          flexShrink: 0,
        }} />
        <code style={{ fontSize: 12 }}>{varName}</code>
        <span style={{ color: '#888', fontSize: 11 }}>{hex.toUpperCase()}</span>
      </Space>
    ),
    value: hex,
  }));

  // ── Helper to patch one meta field ──────────────────────────────────────────
  const patchMeta = (key, val) =>
    setSkillsMeta(prev => ({ ...prev, [key]: val }));

  return (
    <>
      {/* ── Page header ─────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <Title level={4} style={{ margin: 0 }}>Skill Groups</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Add Group</Button>
      </div>

      {/* ── Floating image settings card ─────────────────────────────────────── */}
      <Card
        title={
          <Space>
            <PictureOutlined />
            <span>Floating Parallax Image</span>
          </Space>
        }
        size="small"
        style={{ marginBottom: 24 }}
        extra={
          <Button
            type="primary"
            size="small"
            loading={metaSaving}
            onClick={saveSkillsMeta}
          >
            Save
          </Button>
        }
      >
        {/* URL input */}
        <Text type="secondary" style={{ display: 'block', marginBottom: 8, fontSize: 12 }}>
          Image URL
        </Text>
        <Input
          placeholder="https://..."
          value={skillsMeta.floatingImage}
          onChange={e => patchMeta('floatingImage', e.target.value)}
          onPressEnter={saveSkillsMeta}
          style={{ marginBottom: 16 }}
        />

        {/* Width sliders */}
        <Row gutter={32}>
          <Col span={12}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Desktop width — <strong>{skillsMeta.desktopWidthVw}vw</strong>
            </Text>
            <Slider
              min={5}
              max={60}
              value={skillsMeta.desktopWidthVw}
              onChange={v => patchMeta('desktopWidthVw', v)}
              tooltip={{ formatter: v => `${v}vw` }}
              marks={{ 5: '5', 22: '22', 40: '40', 60: '60' }}
            />
          </Col>
          <Col span={12}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Mobile width — <strong>{skillsMeta.mobileWidthVw}vw</strong>
            </Text>
            <Slider
              min={20}
              max={90}
              value={skillsMeta.mobileWidthVw}
              onChange={v => patchMeta('mobileWidthVw', v)}
              tooltip={{ formatter: v => `${v}vw` }}
              marks={{ 20: '20', 48: '48', 70: '70', 90: '90' }}
            />
          </Col>
        </Row>

        {/* Live preview */}
        {skillsMeta.floatingImage && (
          <div style={{ marginTop: 8 }}>
            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 6 }}>Preview</Text>
            <img
              src={skillsMeta.floatingImage}
              alt="Floating image preview"
              style={{
                // Mirror the desktop vw as a px preview at 1/4 scale so it's visible in the card
                width:        `${skillsMeta.desktopWidthVw * 0.25}vw`,
                minWidth:     60,
                maxWidth:     '100%',
                height:       'auto',
                borderRadius: 6,
                border:       '1px solid #f0f0f0',
                display:      'block',
              }}
              onError={e => {
                e.currentTarget.style.display = 'none';
                message.warning('Could not load image — check the URL');
              }}
              onLoad={e => { e.currentTarget.style.display = 'block'; }}
            />
            <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
              Shown at ¼ of desktop width for reference
            </Text>
          </div>
        )}
      </Card>

      {/* ── Skill group cards ────────────────────────────────────────────────── */}
      {loading ? <div>Loading...</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
          {data.map(group => (
            <Card
              key={group.id}
              title={<Tag color={group.color} style={{ color: '#000', fontWeight: 700 }}>{group.cat}</Tag>}
              extra={
                <Space>
                  <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(group)} />
                  <Popconfirm title="Delete this group?" onConfirm={() => handleDelete(group.id)}>
                    <Button size="small" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Space>
              }
              size="small"
            >
              {(group.items || []).map((item, idx) => (
                <div key={idx} style={{ marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                    <span style={{ fontSize: 13 }}>{itemName(item)}</span>
                    <span style={{ fontSize: 12, color: '#888' }}>{itemLevel(item)}%</span>
                  </div>
                  <Progress percent={itemLevel(item)} strokeColor={group.color} showInfo={false} size="small" />
                </div>
              ))}
            </Card>
          ))}
        </div>
      )}

      {/* ── Add / Edit modal ─────────────────────────────────────────────────── */}
      <Modal
        title={editing ? 'Edit Skill Group' : 'Add Skill Group'}
        open={modalOpen}
        onOk={handleSave}
        onCancel={() => setModalOpen(false)}
        okText="Save"
        width={520}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="cat" label="Category Name" rules={[{ required: true }]}>
            <Input placeholder="Frontend" />
          </Form.Item>

          {/* Accent colour */}
          <Form.Item name="color" label="Accent Color">
            <Select
              loading={themeLoading}
              options={colorOptions}
              optionLabelProp="label"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: '8px 0' }} />
                  <div style={{ padding: '4px 8px 8px' }}>
                    <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Add new colour to theme</div>
                    <Space.Compact style={{ width: '100%' }}>
                      <Input
                        placeholder="--variable-name"
                        value={newVarName}
                        onChange={e => setNewVarName(e.target.value)}
                        style={{ fontFamily: 'monospace', flex: 1 }}
                        onPressEnter={handleAddThemeColor}
                      />
                      <Tooltip title="Pick colour">
                        <div style={{ position: 'relative', width: 32, flexShrink: 0 }}>
                          <div style={{
                            width: 32, height: 32,
                            background: newVarHex,
                            border: '1px solid #d9d9d9',
                            borderLeft: 'none',
                            cursor: 'pointer',
                          }} />
                          <input
                            type="color"
                            value={newVarHex}
                            onChange={e => setNewVarHex(e.target.value)}
                            style={{ position: 'absolute', inset: 0, opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                          />
                        </div>
                      </Tooltip>
                      <Input
                        value={newVarHex.toUpperCase()}
                        maxLength={7}
                        style={{ fontFamily: 'monospace', width: 90 }}
                        onChange={e => {
                          let hex = e.target.value.trim();
                          if (!hex.startsWith('#')) hex = '#' + hex;
                          if (/^#[0-9a-fA-F]{6}$/.test(hex)) setNewVarHex(hex);
                        }}
                      />
                      <Button icon={<PlusOutlined />} onClick={handleAddThemeColor} />
                    </Space.Compact>
                  </div>
                </>
              )}
            />
          </Form.Item>

          {/* Colour preview */}
          <Form.Item shouldUpdate={(prev, curr) => prev.color !== curr.color} noStyle>
            {({ getFieldValue }) => {
              const hex     = getFieldValue('color');
              const varName = hex ? hexToVarName(hex) : null;
              return hex ? (
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  marginTop: -12, marginBottom: 16,
                  padding: '6px 10px',
                  background: '#fafafa',
                  borderRadius: 6,
                  border: '1px solid #f0f0f0',
                }}>
                  <div style={{
                    width: 22, height: 22, borderRadius: 4,
                    background: hex, flexShrink: 0,
                    border: '1px solid rgba(0,0,0,0.1)',
                  }} />
                  {varName && <code style={{ fontSize: 12, color: '#555' }}>{varName}</code>}
                  <span style={{ fontSize: 12, color: '#888', fontFamily: 'monospace' }}>{hex.toUpperCase()}</span>
                </div>
              ) : null;
            }}
          </Form.Item>

          <Divider>Skills</Divider>

          {items.map((item, i) => (
            <Space key={i} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
              <Input
                placeholder="Skill name"
                value={item.name}
                onChange={e => updateItem(i, 'name', e.target.value)}
                style={{ width: 200 }}
              />
              <InputNumber
                min={0} max={100}
                value={item.level}
                onChange={v => updateItem(i, 'level', v)}
                formatter={v => `${v}%`}
                parser={v => v.replace('%', '')}
                style={{ width: 90 }}
              />
              <Button danger size="small" onClick={() => removeItem(i)} disabled={items.length === 1}>✕</Button>
            </Space>
          ))}

          <Button type="dashed" onClick={addItem} icon={<PlusOutlined />} style={{ width: '100%' }}>
            Add Skill
          </Button>
        </Form>
      </Modal>
    </>
  );
}